import { makeStyles } from '@fluentui/react-components';
import ReactDomServer from 'react-dom/server';
import { TreeLineIcon } from './TreeLineIcon';

const treeLineFirstChildDataUri: string = encodeURIComponent(ReactDomServer.renderToString(<TreeLineIcon width={8} height={21} />));
const treeLineSubsequentChildDataUri: string = encodeURIComponent(ReactDomServer.renderToString(<TreeLineIcon width={8} height={27} />));

export const useTreeLineStyles = makeStyles({
    firstChild: {
        '& > div:first-child::before': {
            content: `url('data:image/svg+xml;utf8,${treeLineFirstChildDataUri}')`,
            display: 'inline',
            left: '33px',
            position: 'absolute',
            top: '-7px',
        },
        textAlign: 'left',
        userSelect: '',
    },
    subsequentChild: {
        '& > div:first-child::before': {
            content: `url('data:image/svg+xml;utf8,${treeLineSubsequentChildDataUri}')`,
            display: 'inline',
            left: '33px',
            position: 'absolute',
            top: '-13px',
        },
        textAlign: 'left',
        userSelect: '',
    },
});
